import { z } from 'zod';

import { mongoIdSchema } from './shared';

export enum SystemConfigKey {
  Plans = 'plans',
  Features = 'features',
  Maintenance = 'maintenance',
}

export const systemConfigCreateSchema = z.object({
  key: z.nativeEnum(SystemConfigKey),
  value: z.string(),
});
export type SystemConfigCreate = z.infer<typeof systemConfigCreateSchema>;

export const systemConfigSchema = z
  .object({
    _id: mongoIdSchema,
    createdAt: z.number(),
    updatedAt: z.number(),
  })
  .merge(systemConfigCreateSchema);

export type SystemConfig = z.infer<typeof systemConfigSchema>;

// Maintenance Config Types
export enum MaintenanceSeverity {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

export const maintenanceConfigValueSchema = z.object({
  active: z.boolean(),
  message: z.string(),
  severity: z.nativeEnum(MaintenanceSeverity),
});

export type MaintenanceConfigValue = z.infer<typeof maintenanceConfigValueSchema>;
